import { Currency } from '../../constants';
import { Product } from '../product/product';

export type CompetitorProduct = {
  sku: string;
  name: string;
  brand: string;
  productLink: string;
  category: string[];
  size: string;
  pack: string;
  modifiedAt: string;
  normalizedName: string;
  productImageUrls: string[];
  price: Array<{
    originalPrice: number;
    currency: Currency;
    salesPrice: number;
  }>;
  possibility: number;
};

export type CompetitorProductOnlyClient = {
  sku: string;
  name: string;
  brand: string;
  productLink: string;
  category: string[];
  size: string;
  pack: string;
  modifiedAt: string;
  normalizedName: string;
  productImageUrls: string[];
  price: {
    originalPrice: number;
    currency: Currency;
    salesPrice: number;
  };
  possibility: number;
};

export type CompetitorMatchedProduct = {
  skinSeoulProduct: Product;
  machineMatchedProducts: Array<{
    competitor: string;
    competitorProducts: CompetitorProduct[];
  }>;
  humanMatchedProducts: Array<{
    competitor: string;
    competitorProducts: CompetitorProduct[];
  }>;
  modifiedAt: string;
};
